<script lang="ts">
    export let activeTab: string;
    export let onSwitchTab: (tab: string) => void;
    export let labels: { blogs: string; news: string };

    const tabs = [
        { id: 'blogs', label: labels.blogs },
        { id: 'news', label: labels.news }
    ];
</script>

<div class="flex items-center gap-4 border-b border-gray-200 mt-6" data-testid="tabs">
    {#each tabs as { id, label }}
        <button
                on:click={() => onSwitchTab(id)}
                class={`pb-2 text-lg text-gray-500 cursor-pointer transition-colors ${
                activeTab === id 
                    ? 'font-bold !text-black !border-b-2 !border-black' 
                    : 'hover:text-gray-700'
            }`}
                data-testid={`tab-${id}`}
        >
            {label}
        </button>
        {#if id !== tabs[tabs.length - 1].id}
            <div class="h-10 w-px bg-gray-200"></div>
        {/if}
    {/each}
</div>
